export default __webpack_public_path__ + "static/media/pinterest.1682a9e8.svg";